module.exports = __webpack_public_path__ + "img/21.f00a5f15.jpg";